import { render, staticRenderFns } from "./bsp-query.vue?vue&type=template&id=58c40e7c&scoped=true&"
import script from "./bsp-query.vue?vue&type=script&lang=js&"
export * from "./bsp-query.vue?vue&type=script&lang=js&"
import style0 from "./bsp-query.vue?vue&type=style&index=0&id=58c40e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c40e7c",
  null
  
)

export default component.exports